// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5870":"css/admin-app.6727","7824":"css/app.6727"}[chunkId] + ".css";
};